import React from 'react'
import Back from '../assets/backImg.png'
import Arrow2 from '../assets/arrow2.png'
import '../styles/background.css'

const Background = () => {
  return (
    <div className="background">
      <p className="t t-1">&lt;body&gt;</p>
      <p className="t t-2">&lt;html&gt;</p>
      <p className="t t-3">&lt;div&gt;</p>
      <p className="t t-4">&lt;img&gt;</p>
      <p className="t t-5">&lt;object&gt;</p>
      <p className="t t-6">&lt;code&gt;</p>
      <p className="t t-7">&lt;nav&gt;</p>
      <p className="t t-8">&lt;figure&gt;</p>
      <p className="t t-9">&lt;output&gt;</p>
      <p className="t t-10">&lt;p&gt;</p>
      <p className="t t-11">&lt;param&gt;</p>
      <p className="t t-12">&lt;script&gt;</p>
      <p className="t t-13">&lt;time&gt;</p>
      <p className="t t-14">&lt;track&gt;</p>
      <p className="t t-15">&lt;ul&gt;</p>
      <p className="t t-16">&lt;style&gt;</p>
      <p className="t t-17">&lt;option&gt;</p>
      <p className="t t-18">&lt;main&gt;</p>
      <p className="t t-19">&lt;header&gt;</p>
      <p className="t t-20">&lt;label&gt;</p>
      <p className="t t-21">&lt;form&gt;</p>
      <p className="t t-22">&lt;iframe&gt;</p>
      <p className="t t-23">&lt;legend&gt;</p>
      <p className="t t-24">&lt;progress&gt;</p>


      <p className="d d-1">.....</p>
      <p className="d d-2">.....</p>
      <p className="d d-3">.....</p>
      <p className="d d-4">.....</p>
      <p className="d d-5">.....</p>
      <p className="d d-6">.....</p>
      <p className="d d-7">.....</p>
      <p className="d d-8">.....</p>
      <p className="d d-9">.....</p>
      <p className="d d-10">.....</p>
      <p className="d d-11">.....</p>
      <p className="d d-12">.....</p>
      <p className="d d-13">.....</p>
      <p className="d d-14">.....</p>
      <p className="d d-15">.....</p>
      <p className="d d-16">.............</p>
      <p className="d d-17">.....</p>
      <p className="d d-18">.....</p>
      <p className="d d-19">.....</p>
      <p className="d d-20">.....</p>
      <p className="d d-21">.....</p>
      <p className="d d-22">.....</p>

      <img alt="" className="ar ar-1" src={Arrow2}/>
      <img alt="" className="ar ar-2" src={Arrow2}/>
      <img alt="" className="ar ar-3" src={Arrow2}/>
      <img alt="" className="ar ar-4" src={Arrow2}/>
      <img alt="" className="ar ar-5" src={Arrow2}/>
      <img alt="" className="ar ar-6" src={Arrow2}/>
      <img alt="" className="ar ar-7" src={Arrow2}/>
      <img alt="" className="ar ar-8" src={Arrow2}/>
      <img alt="" className="ar ar-9" src={Arrow2}/>
      <img alt="" className="ar ar-10" src={Arrow2}/>
      <img alt="" className="ar ar-11" src={Arrow2}/>
      <img alt="" className="ar ar-12" src={Arrow2}/>
      <img alt="" className="ar ar-13" src={Arrow2}/>
      <img alt="" className="ar ar-14" src={Arrow2}/>
      <img alt="" className="ar ar-15" src={Arrow2}/>
      <img alt="" className="ar ar-16" src={Arrow2}/>

        <img alt="" className="back-img back-mb" src={Back}/>
        <img alt="" className="back-img rot" src={Back}/>
        <img alt="" className="back-img back-mb" src={Back}/>
        <img alt="" className="back-img rot" src={Back}/>
        <img alt="" className="back-img back-mb" src={Back}/>
        <img alt="" className="back-img rot" src={Back}/>


    </div>
  )
}

export default Background